import React from "react";
import Grid from '@mui/material/Grid2';
import CardTutor from "./component/CardTutor";
import { FaStar } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import { useState, useEffect, useMemo } from "react";
import "./styles/Contenido.css";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";
import $ from "jquery";

const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%", // Ancho completo
      height: "50px", // Altura fija
      background: 'transparent',
      border: '2px solid var(--border-color)',
      borderRadius: '40px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(255, 255, 255, 0.5)' : 'none',
      fontSize: '16px',
      maxHeight: '70px', // Altura máxima del Select
      overflowY: 'auto', // Permite desplazamiento interno
      color: '#000',
      '&:hover': {
        borderColor: 'var(--border-color)',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000', // Cambiar el color del texto
    }),
    input: (provided) => ({
      ...provided,
      color: '#000', // Color del texto mientras se escribe
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--text-principal)', // Color del placeholder
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
      color: '#000',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.3)',
      },
    }),
    ValueContainer: (provided) => ({
        ...provided,
        maxHeight: '10px', // Limita la altura del contenedor de valores seleccionados
        overflowY: 'auto', // Habilitar desplazamiento dentro del contenedor
    }),
  };

const tematicas = [
    {value: "Programación", label: "Programación"},
    {value: "Programación web", label: "Programación web"},
    {value: "Programación de aplicaciones móviles", label: "Programación de aplicaciones móviles"},
    {value: "Lenguajes de programación", label: "Lenguajes de programación"},
    {value: "Java", label: "Java"},
    {value: "C++", label: "C++"},
    {value: "Python", label: "Python"},
    {value: "JavaScript", label: "JavaScript"},
    {value: "Php", label: "Php"},
    {value: "IA", label: "IA"},
    {value: "Emprendimiento", label: "Emprendimiento"},
    {value: "Comunicación", label: "Comunicación"},
    {value: "Ventas", label: "Ventas"},
    {value: "Negocios", label: "Negocios"},
    {value: "Gestión de Proyectos", label: "Gestión de Proyectos"},
    {value: "Recursos Humanos", label: "Recursos Humanos"},
    {value: "Comercio electrónico", label: "Comercio electrónico"},
    {value: "Contabilidad", label: "Contabilidad"},
    {value: "Finanzas", label: "Finanzas"},
    {value: "Economía", label: "Economía"},
    {value: "Inversión", label: "Inversión"},
    {value: "Informática", label: "Informática"},
    {value: "Ofimática", label: "Ofimática"},
    {value: "Hardware", label: "Hardware"},
    {value: "Desarrollo Personal", label: "Desarrollo Personal"},
    {value: "Diseño", label: "Diseño"},
    {value: "Diseño Gráfico", label: "Diseño Gráfico"},
    {value: "Diseño 3D y animación", label: "Diseño 3D y animación"},
    {value: "Diseño de moda", label: "Diseño de moda"},
    {value: "Diseño arquitectónico", label: "Diseño arquitectónico"},
    {value: "Diseño de interiores", label: "Diseño de interiores"},
    {value: "Marketing", label: "Marketing"},
    {value: "Marketing digital", label: "Marketing digital"},
    {value: "Marca personal", label: "Marca personal"},
    {value: "Arte y manualidades", label: "Arte y manualidades"},
    {value: "Pintura", label: "Pintura"},
    {value: "Dibujo", label: "Dibujo"},
    {value: "Cocina", label: "Cocina"},
    {value: "Fotografía y vídeo", label: "Fotografía y vídeo"},
    {value: "Nutrición", label: "Nutrición"},
    {value: "Deporte y fitness", label: "Deporte y fitness"},
    {value: "Música", label: "Música"},
    {value: "Ingeniería", label: "Ingeniería"},
    {value: "Humanidades", label: "Humanidades"},
    {value: "Filosofía", label: "Filosofía"},
    {value: "Lengua y literatura", label: "Lengua y literatura"},
    {value: "Matemáticas", label: "Matemáticas"},
    {value: "Ciencia", label: "Ciencia"},
    {value: "Física", label: "Física"},
    {value: "Química", label: "Química"},
    {value: "Biología", label: "Biología"},
    {value: "Geología", label: "Geología"},
    {value: "Ciencias Sociales", label: "Ciencias Sociales"},
    {value: "Psicología", label: "Psicología"},
    {value: "Historia", label: "Historia"},
    {value: "Historia del arte", label: "Historia del arte"},
    {value: "Geografía", label: "Geografía"},
    {value: "Idiomas", label: "Idiomas"},
    {value: "Idioma Inglés", label: "Idioma Inglés"},
    {value: "Idioma Español", label: "Idioma Español"},
    {value: "Idioma Francés", label: "Idioma Francés"},
    {value: "Idioma Alemán", label: "Idioma Alemán"},
    {value: "Idioma Ruso", label: "Idioma Ruso"},
    {value: "Idioma Chino", label: "Idioma Chino"},
    {value: "Idioma Árabe", label: "Idioma Árabe"},
    {value: "Idioma Japonés", label: "Idioma Japonés"},
    {value: "Formación de profesorado", label: "Formación de profesorado"},
    {value: "Preparación para examenes oficiales", label: "Preparación para examenes oficiales"},
];

const Tutores = () => {

    useEffect(() => {
            $(".filtros").hide().slideDown(400);
    
            return () => {
                $(".filtros").stop(true, true).show();
            };
    }, []);

    //Obtener tutores, la información extra y la ordenación
    const [tutores, setTutores] = useState([]);
    const [OrdenSeleccionado, setOrdenSeleccionado] = useState("alfabetico");
    const [tutoresCompletos, setTutoresCompletos] = useState([]);

    //Filtros
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [valoracionSeleccionada, setValoracionSeleccionada] = useState("todas");

    //tags de búsqueda por palabras
    const [tags, setTags] = useState([]);
    const [tag, setTag] = useState("");

    //Manejar tags
    const handleTags = (e) => {
        const codigo = e.keyCodigo || e.which;
        const newTag = tag.trim();

        //cuando se presiona enter (código 13) o coma (código 188)
        if((codigo !== 13 && codigo !== 188) || tag.length === 0){
            return;
        }
        if(!tags.includes(newTag)){
            setTags([...tags, newTag])
        }
        setTimeout(() => {
            setTag(""); 
        }, 0);
    } 
    const eliminarTag = (index) => {
        const TagsMod = [...tags];
        TagsMod.splice(index, 1);
        setTags(TagsMod)
    }

    //Manejar Select (multiples opciones)
    const handleSelect = (selectedOption) => {
        setSelectedOptions(selectedOption);
    };

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';

    //Obtener tutores
    const getTutores = async() => {
        try{
            const response = await fetch(`${baseUrl}/api/users/`, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json', 
                },
            });

        
            if (!response.ok) {
                throw new Error("Usuarios no encontrados o error en la respuesta");
            }

            const usuarios = await response.json();
           
            //filtrar por tipo de usuarios
            const tutores = usuarios.filter(us => us.Tipo === "Tutor");
            tutores.sort((a,b) => a.Nombre.localeCompare(b.Nombre));

            setTutores(tutores);
            
        } catch (error) {
            console.error("Error al obtener los tutores" + error.message);
        }
    };
    
    useEffect(() => {
        getTutores();
    }, []);

    //Añadir información sobre valoración al tutor
    useEffect(() => {
        if(tutores.length === 0) return;

        const fetchExtraInfo = async () => {
            const tutCompletos = await Promise.all(
                tutores.map(async (tut) => {
                    //Obtener el contenido subido por el tutor
                    try {
                        //Obtener clases y cursos
                        const clasesResponse = await fetch(
                            `${baseUrl}/api/clases/search/tutor/${tut._id}`,
                            {
                                method: "GET",
                                headers: { "Content-Type": "application/json" }
                            }
                        );
                        const cursosResponse = await fetch(
                            `${baseUrl}/api/cursos/search/tutor/${tut._id}`,
                            {
                                method: "GET",
                                headers: { "Content-Type": "application/json" }
                            }
                        );
                        
                        if (!clasesResponse.ok || !cursosResponse.ok) {
                            throw new Error("Error al obtener el contenido del tutor");
                        }

                        let clases = await clasesResponse.json();
                        let cursos = await cursosResponse.json();

                        const filtrarEliminados = (contenido) => {
                            return contenido.Nombre !== null &&
                                contenido.Descripcion !== null &&
                                contenido.Tematica !== null &&
                                contenido.ImagenPortada !== null &&
                                contenido.FechaSubida !== null;
                        };

                        clases = clases.filter(filtrarEliminados);
                        cursos = cursos.filter(filtrarEliminados);

                        //Obtener la lista de contenido del tutor 
                        const listaContenido = [...clases, ...cursos];

                                    
                    //Obtener reseñas y calcular la valoración
                    const valoracionPorContenido = await Promise.all(
                       listaContenido.map(async (contenido) => {
                            try{
                                const resValoracion = await fetch(
                                    `${baseUrl}/api/resennas/search/contenido/${contenido._id}`,
                                    {
                                        method: "GET",
                                        headers: { "Content-Type": "application/json" }
                                    }
                                );
                                if(resValoracion.ok){
                                    const resenna = await resValoracion.json();

                                    if(Array.isArray(resenna) && resenna.length > 0){
                                        const suma = resenna.reduce((acum, r) => acum + (r.Valoracion), 0);
                                        return { suma, cantidad: resenna.length };
                                    }
                                    return { suma: 0, cantidad: 0 };
                                }
                                else{
                                    return { suma: 0, cantidad: 0 };
                                }
                                
                            } catch(error){
                                console.error("Error al obtener reseñas para el contenido:", error.message);
                                return { suma: 0, cantidad: 0 };
                            }
                       })
                    );

                    //Sumar todas las valoraciones y contar reseñas
                    const totalSuma = valoracionPorContenido.reduce((acum, { suma }) => acum + suma, 0);
                    const totalReseñas = valoracionPorContenido.reduce((acum, { cantidad }) => acum + cantidad, 0); 

                    const ratingMedia = totalReseñas > 0 ? totalSuma/totalReseñas : 0;
                    return { ...tut, rating: ratingMedia};
                } catch(error){
                    console.error("Error al procesar el tutor:", error.message);
                    return { ...tut, rating: 0 };
                } 
            })
        );
        setTutoresCompletos(tutCompletos);
    }; 
    fetchExtraInfo();
    }, [tutores]);
    
    //Aplicar filtros
    const tutoresFiltrados = useMemo(() => {
        return tutoresCompletos.filter(tut => {
                    
            //Filtro por búsqueda. Búsqueda Y (Se Muestra si tiene una condición y otra y otra... ), para cambiar a búsqueda tipo or vambiar every por some (tags.some)
            if(tags.length !== 0){
                const coincidenciaTags = tags.every(t => {
                    const coincidenciaUsuarioTut = tut.Usuario.toLowerCase().includes(t.toLowerCase());
                    const coincidenciaCorreoTut = tut.Correo.toLowerCase().includes(t.toLowerCase()); 
                    const coincidenciaTutorNombre = tut.Nombre.toLowerCase().includes(t.toLowerCase()) ||
                        tut.Apellidos.toLowerCase().includes(t.toLowerCase());
                    
                    return coincidenciaUsuarioTut || coincidenciaCorreoTut || coincidenciaTutorNombre;
                });

                if(!coincidenciaTags) return false;
            }
    
            //Filtros por temáticas. Funciona como or, para cambiar a and:
            /*
            if (selectedOptions.length > 0) {
                const tematicasSeleccionadas = selectedOptions.map(op => op.value.toLowerCase());
    
                if (!tut.Tematica || !tematicasSeleccionadas.every(tem => prod.Tematicas.map(t => t.toLowerCase()).includes(tem))) {
                    return false;
                }
            }           
            */
            if(selectedOptions.length > 0){
                const tematicasSeleccionadas = selectedOptions.map(op => op.value.toLowerCase());
                //Verificar que el tutor tenga al menos una temática seleccionada
                if(!tut.Tematicas?.some(tem => tematicasSeleccionadas.includes(tem.toLowerCase()))){
                    return false;
                }
            }
        
            //Filtrar por valoración
            if(valoracionSeleccionada !== "todas"){
                let valorMinimo = 0;
                if(valoracionSeleccionada === "una") valorMinimo = 1;
                if(valoracionSeleccionada === "dos") valorMinimo = 2;
                if(valoracionSeleccionada === "tres") valorMinimo = 3;
                if(valoracionSeleccionada === "cuatro") valorMinimo = 4;
                if(tut.rating < valorMinimo) return false;
            }

            return true;
        });
    }, [
        tutoresCompletos,
        tags,
        selectedOptions,
        valoracionSeleccionada
    ]);

    //Manejar orden
    const manejarOrdenacion = (tipoOrden) => {
        setOrdenSeleccionado(tipoOrden);
    };

    //Ordenar según estado de ordenSeleccionado
    const ordenarTutores = useMemo(() => {
        const ordenacion = [...tutoresFiltrados];
        switch(OrdenSeleccionado){
            case "alfabetico":
                ordenacion.sort((a,b) => a.Nombre.localeCompare(b.Nombre));
                break;
            case "reciente":
                ordenacion.sort((a,b) => new Date(b.FechaCreacion) - new Date(a.FechaCreacion));
                break;
            case "valoracion":
                ordenacion.sort((a, b) => b.rating - a.rating);
                break;
            default:
                break;
        } 
        return ordenacion;
    }, [tutoresFiltrados, OrdenSeleccionado]);
    

    return(
        <>
        <div className='principal'> 
            
            <h1 className="titulo">Tutores</h1>
            
            <div className='contenido'>
                <div className='filtros'>
                    <h2>Filtros</h2>
                    <div className="filtrosContent">
                        <h3>Buscar por palabras</h3>
                        <div className="inputWrapper">
                            <FaSearch className="searchIcon" />
                            <input type="text" placeholder="Escribe para buscar..." value={tag} maxLength={50} onChange={(e) => setTag(e.target.value)} onKeyDown={handleTags}/>
                            {tags.length !== 0 && 
                            <div className="ContenedorTag">
                                {tags.map((tag, index) => (
                                    <div className="tag">
                                        <span className="nombreTag">{tag}</span>
                                        <span className="icono" onClick={() => eliminarTag(index)}>
                                            &times;
                                        </span>
                                    </div>
                                ))}
                            </div>
                            }
                        </div> 
                    </div>
                    <div className="filtrosContent">
                        <h3 style={{ marginTop: tags.length !== 0 ? '25px' : '0px' }}>Seleccionar temáticas</h3>
                        <Select 
                            options={tematicas}
                            value={selectedOptions}
                            isMulti={true}
                            styles={customStyles}
                            placeholder="Filtrar por temáticas"
                            onChange={handleSelect}
                        />
                    </div>
                    <div className="filtrosContent">
                        <h3>Filtrar por valoración</h3>
                        <div className="item">
                            <input type="radio" id="val0" name="filtrar_val" value="todas" checked={valoracionSeleccionada === "todas"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val0">Todas las valoraciones</label>
                        </div>

                        <div className="item">
                            <input type="radio" id="val1" name="filtrar_val" value="una" checked={valoracionSeleccionada === "una"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val1"><FaStar /> <FaRegStar /> <FaRegStar /> <FaRegStar /> <FaRegStar /> o más</label>
                        </div>
                        
                        <div className="item">
                            <input type="radio" id="val2" name="filtrar_val" value="dos" checked={valoracionSeleccionada === "dos"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val2"><FaStar /> <FaStar /> <FaRegStar /> <FaRegStar /> <FaRegStar /> o más</label>
                        </div>
                        
                        <div className="item">
                            <input type="radio" id="val3" name="filtrar_val" value="tres" checked={valoracionSeleccionada === "tres"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val3"><FaStar /> <FaStar /> <FaStar /> <FaRegStar /> <FaRegStar /> o más</label>
                        </div>
                        
                        <div className="item">
                            <input type="radio" id="val4" name="filtrar_val" value="cuatro" checked={valoracionSeleccionada === "cuatro"} onChange={(e) => setValoracionSeleccionada(e.target.value)}/>
                            <label htmlFor="val4"><FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaRegStar /> o más</label>
                        </div>
                    </div>
                </div>
                <div className='contenedorPrincipal'>
                    <div className='ordenacion'>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "alfabetico" ? "active" : ""}`} onClick={() => manejarOrdenacion("alfabetico")}>Alfabético</button>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "reciente" ? "active" : ""}`} onClick={() => manejarOrdenacion("reciente")}>Más recientes</button>
                        <button className={`botonOrdenacion ${OrdenSeleccionado === "valoracion" ? "active" : ""}`} onClick={() => manejarOrdenacion("valoracion")}>Mayor valoración</button>
                    </div>
                
                    <Grid container spacing={2}>
                        {ordenarTutores?.map((tut) => (
                            <div key={tut?._id}>
                                <Grid sx={{ flexBasis: { xs: "100%", sm: "50%", md: "33.33%" } }}>
                                    <CardTutor tutor={tut}/>
                                </Grid>
                            </div>
                        ))}
                    </Grid>
                </div>
            </div>
        </div>

        
        </>
    );
};

export default Tutores;